import React from 'react';
import { Box, Typography } from '@mui/material';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';

import { Button } from '../../components/core';
import { useMerchant } from '../../contexts/MerchantContext';

type Props = {
  onEnable: () => void;
};

export const EllaLanding = ({ onEnable }: Props): JSX.Element => {
  const { canUpdateAgentHub } = useMerchant();

  return (
    <Box
      data-testid="ELLA_LANDING"
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        flexGrow: 1,
        width: '100%',
        height: '100%',
        minHeight: 0,
        px: 3,
        py: 6,
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'flex-start',
          maxWidth: 560,
          width: '100%',
        }}
      >
        <AutoAwesomeIcon sx={{ fontSize: 40, mb: 2.5, color: 'brand.main' }} aria-hidden />
        <Typography
          component="h1"
          sx={{
            display: 'flex',
            boxSizing: 'border-box',
            width: 388,
            height: 36,
            alignItems: 'center',
            mb: 2,
            color: 'primary.dark',
            fontFeatureSettings: "'liga' off, 'clig' off",
            fontFamily: 'Poppins, sans-serif',
            fontSize: 32,
            fontStyle: 'normal',
            fontWeight: 600,
            lineHeight: '36px',
            letterSpacing: '-1.5px',
            whiteSpace: 'nowrap',
          }}
        >
          This merchant isn&apos;t set up with Agent Hub
        </Typography>
        <Typography
          sx={{
            mb: 4,
            maxWidth: 520,
            color: 'primary.dark',
            fontFeatureSettings: "'liga' off, 'clig' off",
            fontFamily: 'Poppins, sans-serif',
            fontSize: 20,
            fontStyle: 'normal',
            fontWeight: 600,
            lineHeight: 'normal',
            letterSpacing: '-0.5px',
          }}
        >
          This merchant does not currently have Agent Hub enabled. To get started setting up Agent
          Hub for this merchant, use the option below.
        </Typography>
        <Button
          theme="primary"
          text="Enable Agent Hub"
          onClick={onEnable}
          disabled={!canUpdateAgentHub()}
          dataTestId="ella-enable-button"
          sx={{ width: 249.798, height: 48, px: 4 }}
        />
      </Box>
    </Box>
  );
};
